<template>
  <div class="page">
    <img v-if="type === 'normal'"
         class="oauth2"
         src="./assets/imgs/oauth2.png"
         @click="toOauth2" />
    <img v-if="type === 'oauth2'"
         class="oauth2"
         src="./assets/imgs/normal.png"
         @click="toNormal" />
    <div class="left"></div>
    <div class="right">
      <div class="header">
        <system-logo />
      </div>
      <div class="body">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { CORE_OAUTH, CORE_ROUTER } from '@/core'
import type { Oauth2Options } from '@/plugins'
import { container } from 'tsyringe'
import { computed } from 'vue'
import { useRoute, type Router } from 'vue-router'
import SystemLogo from './SystemLogo.vue'

const router = container.resolve<Router>(CORE_ROUTER)
const oauth2Plugin = container.resolve<Oauth2Options>(CORE_OAUTH)

const toOauth2 = () => {
  if (!oauth2Plugin.providers.abroadAuth) {
    if (oauth2Plugin.providers.wechat) {
      router.push({ path: '/oauth2/third_parties/wechat' })
    }
  } else {
    router.push({ path: '/oauth2/third_parties/abroadSignin' })
  }
}

const toNormal = () => {
  router.push({ path: '/signin' })
}

const route = useRoute()
const type = computed(() => {
  return route.path.indexOf('oauth2') < 0 ? 'normal' : 'oauth2'
})

</script>

<style lang="less" scoped>
.page {
  height: 100%;
  width: 100%;
  display: flex;
  background-color: #F5F5F5;
  justify-content: center;

  .oauth2 {
    position: absolute;
    cursor: pointer;
    top: 0;
    right: 0;
  }

  .left {
    flex: 1;
    display: flex;
    background: url('./assets/imgs/bg.png') no-repeat;
    background-size: cover;
  }

  .right {
    width: 36%;
    padding: 125px;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .header {
      width: 100%;
      display: flex;
      justify-content: center;
      margin-bottom: 80px;

      h1 {
        color: @primary-color;
        font-weight: bold;
        font-size: xxx-large;
        margin: 0;
      }

      img {
        height: 16vh;
      }
    }

    .title {
      width: 100%;
      margin-top: 24px;
      margin-bottom: 24px;

      h1 {
        width: 96px;
        line-height: 40px;
        font-size: 16px;
        color: @primary-color;
        text-align: center;
        border-bottom: 2px @primary-color solid;
        margin: 0;
      }
    }

    .body {
      width: 100%;
      display: inline-flex;
      flex-direction: column;
      align-items: center;

      :deep(.ant-tabs-ink-bar) {
        bottom: 0;
        height: 4px;
        transform: scaleX(0.5);
      }

      :deep(.ant-tabs-tab) {
        padding: 0px;
        margin-top: 20px;
        margin-bottom: 10px;

        .ant-tabs-tab-btn {
          font-family: 'SourceHanSansCN-Regular';
        }
      }

      :deep(.ant-tabs-tab-active) {
        .ant-tabs-tab-btn {
          font-family: 'SourceHanSansCN-Bold';
        }
      }

      :deep(.ant-input-affix-wrapper) {
        border: none;
        border-bottom: 1px solid #d9d9d9;
      }

      :deep(.ant-input-affix-wrapper:focus) {
        box-shadow: none !important;
      }

      :deep(.ant-input-affix-wrapper-focused) {
        box-shadow: none !important;
      }
    }
  }
}
</style>
